<template>
  <SubmitButtonMagenta
    v-if="isTemplatePublished"
    v-allowed.editor
    spinner-color="#fff"
    :loading="loading"
    :disabled="disabled"
    @click="unplublishTemplate"
  >
    Despublicar
  </SubmitButtonMagenta>
</template>

<script>
// Utils
import { checkApiResponse } from 'Utils'
import { Notification } from 'Utils/Classes/Notification'
import TemplatesStatusControl from '../mixins/statusControl'
import TemplateButtonMixin from '../mixins/templatesButtons'

// Preparing notification
const notification = new Notification()
notification.timeout = 4000

export default {
  name: 'TemplatesUnpublishButton',

  mixins: [TemplateButtonMixin, TemplatesStatusControl],

  methods: {
    async unplublishTemplate() {
      this.toggleLoadingStatus()

      const post = await this.$store.dispatch('templates/updateTemplate', {
        status: 'draft',
      })

      if (!checkApiResponse(post)) return this.toggleLoadingStatus()
      this.toggleLoadingStatus()
      // sending notification
      notification.type = 'success'
      notification.message = `Plantilla despublicada con éxito`
      notification.dispatch()
    },
  },

  computed: {
    template() {
      return this.$store.state.templates.templatePublished
    },
  },
}
</script>

<style scoped></style>
